<script>
import { NavBar, Swipe, SwipeItem } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-entry',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-nav-bar': NavBar,
        'van-swipe': Swipe,
        'van-swipe-item': SwipeItem,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            locale: {}
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        organizationTotal() {
            return '2000+'
        },
        matchTotal() {
            return '2233'
        },
        memberTotal() {
            return '2w+'
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onBackBtnClick: function() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    action: 'exit'
                }
            })
        },
        onCreateMatchBtnClick: function() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateMatchName'
                }
            })
        },
        onManageMatchBtnClick: function() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgSelectOrganization'
                }
            })
        },
    },
}
</script>

<template>
    <div class="match-entry">
        <div class="header">
            <van-nav-bar 
                :title="locale['match-entry']"
                :fixed="true"
                :safe-area-inset-top="true"
                class="primary-nav-bar"
                left-arrow  
                @click-left="onBackBtnClick"
            />
        </div>
        <div class="head">
            <div class="match-create-unit inline-block" @click="onCreateMatchBtnClick">
                <img src="@/assets/org/match-create-unit.png"/>
            </div>
            <div class="match-manage-unit inline-block" @click="onManageMatchBtnClick">
                <img src="@/assets/org/match-manage-unit.png"/>
            </div>
            <div class="stats text-center">
                <van-row type="flex" justify="center">
                    <van-col span="8">
                        <div><span class="title">{{ locale['organization-total'] }}</span></div>
                        <div><span class="label">{{ organizationTotal }}</span></div>
                    </van-col>
                    <van-col span="8">
                        <div><span class="title">{{ locale['match-total'] }}</span></div>
                        <div><span class="label">{{ matchTotal }}</span></div>
                    </van-col>
                    <van-col span="8">
                        <div><span class="title">{{ locale['member-total'] }}</span></div>
                        <div><span class="label">{{ memberTotal }}</span></div>
                    </van-col>
                </van-row>
            </div>
            <div class="advantage">
                <van-swipe 
                    :loop="false" 
                    :width="113" 
                    :show-indicators="false"
                >
                    <van-swipe-item>
                        <img src="@/assets/org/advantage-item-01.png"/>
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/org/advantage-item-02.png"/>
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/org/advantage-item-03.png"/>
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/org/advantage-item-04.png"/>
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/org/advantage-item-05.png"/>
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/org/advantage-item-06.png"/>
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <div class="body">
            <div class="feature">
                <div class="feature-title text-center">
                    <span class="r-outer-margin quote"><img src="@/assets/org/quote-symbol.png"/></span>
                    <span class="label">{{ locale['feature-intro'] }}</span>
                    <span class="l-outer-margin quote"><img src="@/assets/org/quote-symbol.png"/></span>
                </div>
                <div class="feature-content">
                    <van-swipe 
                        :loop="false" 
                        :width="233" 
                        :show-indicators="false"
                    >
                        <van-swipe-item>
                            <img src="@/assets/org/feature-item-01.png"/>
                        </van-swipe-item>
                        <van-swipe-item>
                            <img src="@/assets/org/feature-item-02.png"/>
                        </van-swipe-item>
                        <van-swipe-item>
                            <img src="@/assets/org/feature-item-03.png"/>
                        </van-swipe-item>
                        <van-swipe-item>
                            <img src="@/assets/org/feature-item-04.png"/>
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
            <div class="new-feature">
                 <div class="new-feature-title text-center">
                    <span class="r-outer-margin quote"><img src="@/assets/org/quote-symbol.png"/></span>
                    <span class="label">{{ locale['new-feature'] }}</span>
                    <span class="l-outer-margin quote"><img src="@/assets/org/quote-symbol.png"/></span>
                </div>
                <div class="new-feature-content">
                    <div class="title">
                        <span>{{ locale['new-feature-title-01'] }}</span>
                    </div>
                    <div class="content">
                    <span>{{ locale['new-feature-content-01'] }}</span>
                    </div>
                </div>
                <div class="new-feature-content">
                    <div class="title">
                        <span>{{ locale['new-feature-title-02'] }}</span>
                    </div>
                    <div class="content">
                    <span>{{ locale['new-feature-content-02'] }}</span>
                    </div>
                </div>
                <div class="new-feature-content">
                    <div class="title">
                        <span>{{ locale['new-feature-title-03'] }}</span>
                    </div>
                    <div class="content">
                    <span>{{ locale['new-feature-content-03'] }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.match-entry {
    padding-bottom: 0;
}
.head {
    height: 517px;
    background: url('../../assets/org/match-entry-head-bg.png') no-repeat;
    background-size: 100% 100%;
}
.body {
    height: 983px;
    background: linear-gradient(180deg, #AAD5FF 0%, #D4F6FF 100%);
}
.match-create-unit {
    margin-left: 20px;
    margin-top: 240px;
}
.match-create-unit img {
    width: 165px;
    height: 52px;
}
.match-manage-unit img {
    margin-left: 6px;
    width: 165px;
    height: 52px;
}
.stats {
    padding: 20px 12px;
}
.stats .title {
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1A1F24;
}
.stats .label {
    font-family: PingFang SC;
    font-size: 22px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
}
.advantage {
    margin-left: 12px;
    margin-top: 8px;
}
.advantage img {
    width: 105px;
    height: 105px;
}
.feature-title {
    padding-top: 13px;
}
.feature-title .label {
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
    color: #1C263E;
}
.feature-content {
    margin-left: 12px;
    margin-top: 16px;
}
.feature-content img {
    width: 218px;
    height: 480px;
}
.new-feature-title {
    margin-top: 33px;
    margin-bottom: 3px;
}
.new-feature-title .label {
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
    color: #1C263E;
}
.new-feature-content {
    width: 299px;
    height: 64px;
    margin: 12px;
    border-radius: 8px;
    background: #FFFFFF;
    padding: 10px 26px;
}
.new-feature-content .title span {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
    color: #3D3D3D;
}
.new-feature-content .content {
    margin-top: 6px;
}
.new-feature-content .content span {
    font-family: PingFang SC;
    font-size: 13px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #434343;
}
.quote img {
    width: 27.5px;
    height: 26.5px;
}
</style>